import React, { useState } from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { useAppDispatch } from "../../../../../redux";
import { getFileUrl } from "../../../../../redux/saga/partner-program/calculator/saga-action";

interface CommentsFilesSectionProps {
  isEditable: boolean;
  selectedAssesmentData:any
}

const CommentsFilesSection: React.FC<CommentsFilesSectionProps> = ({
  isEditable,
  selectedAssesmentData
}) => {
  const [comment, setComment] = useState("Comment");
  const dispatch = useAppDispatch();

  const hasComments =
    !!selectedAssesmentData &&
    Array.isArray(selectedAssesmentData.comments) &&
    selectedAssesmentData.comments.length > 0 &&
    !!selectedAssesmentData.comments[0].comment;

  const hasFiles =
    !!selectedAssesmentData &&
    Array.isArray(selectedAssesmentData.documents) &&
    selectedAssesmentData.documents.length > 0;

  if (!hasComments && !hasFiles) {
    return null;
  }

    const downloadFileUrlFn=(fileName:any,fileType:any)=>{
  
      dispatch(getFileUrl(fileName,fileType));
  
    }

  return (
    <>
      <h2>Comments & Files</h2>
      <div className="comments-files-grid">
        {hasComments && (
        <div className="comment-section">
          <label>Comment</label>
          <span className="char-count">{selectedAssesmentData && 
          selectedAssesmentData.comments &&
          selectedAssesmentData.comments[0].comment.length}/500</span>
          {isEditable ? (
            <textarea
              className="form-textarea"
              placeholder="Comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              maxLength={500}
              rows={4}
            />
          ) : (
            <div className="form-value comment-value">{selectedAssesmentData &&
               selectedAssesmentData.comments ? 
              selectedAssesmentData.comments[0].comment : ''}</div>
          )}
        </div>
        )}
        {hasFiles && (
        <div className="files-section">
          {selectedAssesmentData && selectedAssesmentData.documents ? selectedAssesmentData.documents.map((doc:any, index:number) => (
            <div key={index} className="file-item">
              
                <a 
                          //target="_blank"
                          onClick={()=>{
                            downloadFileUrlFn(doc,'view')
                          }}
                           key={index} 
                           //href={doc} 
                           className="document-item">
 <span>{doc}</span>
              <Iconography icon="eye" size={IconographySizes.Small} />
                           </a>
             
            </div>
          )):''}
        </div>
        )}
      </div>
    </>
  );
};

export default CommentsFilesSection;
